module.exports = __webpack_public_path__ + "img/contributing-1.0eeb45a5.png";